import { FormattedMessage } from 'react-intl'

export const getEmailFrequencyObject = (frequency) => {
  const frequencyMap = {
    Never: {
      id: 'never',
      title: <FormattedMessage id="email_notification" />,
      secondaryText: <FormattedMessage id="notification_neverSubText" />,
      'data-api': 'Never'
    },
    Periodically: {
      id: 'periodically',
      title: <FormattedMessage id="notification_periodicallyTitle" />,
      secondaryText: <FormattedMessage id="notification_periodicallySubText" />,
      'data-api': 'Periodically'
    },
    Instantly: {
      id: 'instantly',
      title: <FormattedMessage id="notification_instantlyTitle" />,
      secondaryText: <FormattedMessage id="notification_instantlySubText" />,
      'data-api': 'Instantly'
    }
  }

  return frequencyMap[frequency] || null
}
